import { Accordion, Select, Stack, Switch, Text, TextInput } from '@mantine/core';
import { MEETING_PLATFORM_OPTIONS } from '../../../../config/cohortConfig';
import type { EditCohortForm } from './editCohortTypes';

interface GeneralConfigSectionProps {
  form: EditCohortForm;
}

export function GeneralConfigSection({ form }: GeneralConfigSectionProps) {
  // MED-1069 (E1.10c) — Commitment Tracking was relocated from this cohort-level
  // "Live Session Delivery" subheading to the group coaching modality card in
  // ModalitySettingsSection. General Configuration now holds meeting defaults only.
  return (
    <Accordion.Item value="general-config">
      <Accordion.Control>
        <Text fw={600}>General Configuration</Text>
      </Accordion.Control>
      <Accordion.Panel>
        <Stack gap="md">
          <TextInput
            label="Default Meeting Link"
            placeholder="Join Meeting | Zoom ..."
            description="Used as the default video link for sessions unless overridden"
            {...form.getInputProps('default_meeting_link')}
          />
          <Select
            label="Default Meeting Platform"
            placeholder="Select platform"
            description="Auto-populates meeting links from coach profiles when finalizing sessions"
            data={MEETING_PLATFORM_OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
            value={form.values.default_meeting_platform || null}
            onChange={(value) => form.setFieldValue('default_meeting_platform', value || '')}
            clearable
          />
          <Switch
            color="medleyGreen"
            label="Show Zoom meeting ID and passcode in invites"
            description="Adds them under the Join Meeting line of group session and workshop invites. The passcode comes from the coach profile whose Zoom link matches. Use Resend Invites to update invites already sent."
            {...form.getInputProps('show_zoom_dial_in', { type: 'checkbox' })}
          />
        </Stack>
      </Accordion.Panel>
    </Accordion.Item>
  );
}
